import type { PagedResultDto } from "@services/dto/pagedResultDto"
import zoneService from "@services/master-data/zoneService"
import { action, makeAutoObservable, observable } from "mobx"
import { appDataStoreInstance as appDataStore } from "../appDataStore"

class ZoneStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any

  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
  }

  @action
  async createOrUpdate(body: any) {
    this.isLoading = true
    const result = await zoneService
      .createOrUpdate(body)
      .finally(() => (this.isLoading = false))
    this.detailData = result
    if (!body.id) {
      this.tableData.items.push(result)
    } else {
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
    appDataStore.getListZone()
  }

  @action
  async newTownShip() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async active(id: number, isActive) {
    this.isLoading = true
    await zoneService
      .activate(id, isActive)
      .finally(() => (this.isLoading = false))
    appDataStore.getListZone()
  }

  @action
  async get(id: number) {
    this.isLoading = true
    const result = await zoneService
      .get(id)
      .finally(() => (this.isLoading = false))
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await zoneService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
}

export default ZoneStore
